const routes = [
  {
    path: '/settings/staff_profile/:uid?',
    name: 'staffProfile',
    component: () => import(/* webpackChunkName: "MyProfilePage" */ './views/MyProfilePage.vue'),
    props: (route) => ({
      ...route.query,
      ...route.params,
    }),
    meta: { i18n: 'staff-pov' },
  },
];

export default routes;
